<template>
	<div  class="st-login st-animate st-animate--fadeIn">
	    <div class="row">
	        <div class="col-xs-12 text-center margin-bottom-medium">
	            <h1 class="st-headline st-headline--1">{{ $t('Innovative Minutes') }}</h1>
	        </div>
	    </div>
	    <form ref="form" @submit.prevent="submit" method="post">
		    <div class="row">
		        <div class="col-xs-12 margin-bottom-medium">
					<input
					autofocus
					type="email"
					name="email"
					class="st-input st-input--full"

					ref="email"
					v-validate="{email: true, required: true}"
					v-model="email"
					:class="{'st-input--error': errors.has('email')}"
					:placeholder="$t('Email address')"
					:disabled="loading || saveing">
					<div class="error" v-show="errors.has('email')">
						{{ errors.first('email') }}
					</div>
		        </div>
		        <div class="col-xs-12 margin-bottom-medium">
					<input
					autofocus
					type="password"
					name="password"
					class="st-input st-input--full"
					v-if="!forgot"

					ref="password"
					v-validate="{required: true}"
					v-model="password"
					:class="{'st-input--error': errors.has('password')}"
					:placeholder="$t('Password')"
					:disabled="loading || saveing">
					<div class="error" v-show="errors.has('password')">
						{{ errors.first('password') }}
					</div>
		        </div>
		        <div class="col-xs-12 margin-bottom-medium">
		            <button class="st-btn st-btn--full st-btn--primary" :class="{'st-btn--loading':loading || saveing}" :disabled="loading || saveing">
		            	<span v-if="!forgot">{{ $t('Sign in') }}</span>
		            	<span v-else>{{ $t('Request new Password') }}</span>
			        </button>
		        </div>
		        <div class="col-xs-12 text-center">
		            <a @click.prevent="toggleForgot" href="#" class="link"  :class="{'link--loading':loading || saveing}" :disabled="loading || saveing">
		            	<span v-if="!forgot">{{ $t('Password forgot?') }}</span>
		            	<span v-else>{{ $t('Switch to Login') }}</span>
					</a>
		        </div>
		    </div>
	    </form>
	    <div class="row">
	        <div class="col-xs-12">
				<div class="notices" ref="panelnotes">
					<div v-if="notices.length > 0" class="margin-top-large margin-bottom-xlarge">
						<v-notice v-for="(data, index) in notices" :key="data.id" :data="data"></v-notice>
					</div>
				</div>
	        </div>
	    </div>
	</div>
</template>

<script>
import help_rest from '@/helpers/rest';

import isEmpty from 'lodash/isEmpty';

export default {
	name: 'p-loginform',
	computed: {
		saveing(){
			return this.$store.getters.saveing;
		},
		loading(){
			return this.$store.getters.loading;
		},
		notices(){
			const notices = this.$store.getters.notices;
			return notices;
		},
	},
	data(){
		return {
			forgot: false,
			email: '',
			password: '',
		}
	},
	methods: {
		...help_rest,
		toggleForgot(){
			this.forgot = !this.forgot;
		},
		submit() {
			const self = this;
			this.$validator.validateAll()
			.then(result => {
				if (result) {
					if(self.forgot){
						self.restpatch('/api/v1/request_password', {email:self.email}, 'request_password')
						.then(message => {
							console.log(message);
						});
					} else {
						self.restpatch('/api/v1/login', {email:self.email, password:self.password}, 'login')
						.then(message => {
							if(!isEmpty(message)) self.$emit('login', message);
						});
					}
				}
			}).catch((err) => {
				console.log(err);
			});
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/p-loginform.vue